import { Alert, Col, Form } from "antd";
import React from "react";
import { componentType } from "../../constants/index";

interface QmAlertProps {
    type: any;
    itemData: any;
}
export const QmAlert = ({ type, itemData }: QmAlertProps) => {
    return (
        <Col xs={24} md={itemData.colSize}>
            <Form.Item>
                {type === componentType.alert && (
                    <Alert message={itemData["@etiqueta"]} description={itemData.value} type="error" />
                )}
            </Form.Item>
        </Col>
    );
};
